<template>
    <div>
        <MobileMenu />
        <div class="flex z-0">
            <!-- BEGIN: Side Menu -->
            <nav class="side-nav">
                <!-- BEGIN: Logo -->
                <!--<router-link :to="{ name: 'side-menu-inicio' }" tag="a" class="intro-x flex items-center pl-5 pt-4">
                    <img alt="Gestión Documental" class="w-6" src="@/assets/images/logo.svg" />
                    <span class="hidden xl:block text-white text-xl ml-3">
                        FIRECAM <span class="font-black text-theme-12">C.A.E.</span>
                    </span>
                </router-link>-->
                <a href="/" class="intro-x flex items-center pl-5 pt-4 router-link-exact-active router-link-active" aria-current="page"><img alt="Gestión Documental" src="/img/logo.95607cf7.svg" class="w-6"><span class="hidden xl:block text-white text-xl ml-3"> FIRECAM <span class="font-black text-theme-12">C.A.E.</span></span></a>
                <!-- END: Logo -->
                <div class="side-nav__devider my-6"></div>
                <div class="px-6 pb-4">
                    <div v-if="user && user.nombre_de_la_empresa && isAdmin" class="text-gray-200 font-medium mb-2">Viendo:</div>
                    <div v-if="user && user.nombre_de_la_empresa" class="text-white font-medium text-lg">{{ user.nombre_de_la_empresa }}</div>
                    <div v-if="user.centro" class="text-xs text-theme-41 dark:text-gray-600">
                        {{ user.centro.nombre_del_centro }}
                    </div>
                    <div @click="emitVisionGlobal" v-if="user && user.nombre_de_la_empresa && isAdmin" class="text-gray-200 font-medium mt-2 underline cursor-pointer">Regresar a visión global</div>
                </div>
                <ul>
                    <!-- BEGIN: First Child -->
                    <template v-for="(menu, menuKey) in formattedMenu" v-if="!menu.hidden">
                        <li v-if="menu == 'devider'" :key="menuKey" class="side-nav__devider my-6"></li>
                        <li v-else :key="menuKey">
                            <SideMenuTooltip tag="a" :content="menu.title" href="javascript:;" class="side-menu" :class="{'side-menu--active': menu.active,'side-menu--open': menu.activeDropdown}" @click.native="linkTo(menu)">
                                <div class="side-menu__icon">
                                    <component :is="menu.icon" />
                                </div>
                                <div class="side-menu__title">
                                    {{ menu.title }}
                                    <ChevronDownIcon v-if="$h.isset(menu.subMenu)" class="side-menu__sub-icon" :class="{ 'transform rotate-180': menu.activeDropdown }" />
                                </div>
                            </SideMenuTooltip>
                            <!-- BEGIN: Second Child -->
                            <transition @enter="enter" @leave="leave">
                                <ul v-if="$h.isset(menu.subMenu) && menu.activeDropdown">
                                    <li v-for="(subMenu, subMenuKey) in menu.subMenu" :key="subMenuKey">
                                        <SideMenuTooltip tag="a" :content="subMenu.title" href="javascript:;" class="side-menu" :class="{ 'side-menu--active': subMenu.active }" @click.native="linkTo(subMenu)">
                                            <div class="side-menu__icon">
                                                <ActivityIcon />
                                            </div>
                                            <div class="side-menu__title">
                                                {{ subMenu.title }}
                                                <ChevronDownIcon v-if="$h.isset(subMenu.subMenu)" class="side-menu__sub-icon" :class="{'transform rotate-180': subMenu.activeDropdown}" />
                                            </div>
                                        </SideMenuTooltip>
                                        <!-- BEGIN: Third Child -->
                                        <transition @enter="enter" @leave="leave">
                                            <ul v-if="$h.isset(subMenu.subMenu) && subMenu.activeDropdown">
                                                <li v-for="(lastSubMenu,lastSubMenuKey) in subMenu.subMenu" :key="lastSubMenuKey">
                                                    <SideMenuTooltip tag="a" :content="lastSubMenu.title" href="javascript:;" class="side-menu" :class="{ 'side-menu--active': lastSubMenu.active }" @click.native="linkTo(lastSubMenu)">
                                                        <div class="side-menu__icon">
                                                            <ZapIcon />
                                                        </div>
                                                        <div class="side-menu__title">
                                                            {{ lastSubMenu.title }}
                                                        </div>
                                                    </SideMenuTooltip>
                                                </li>
                                            </ul>
                                        </transition>
                                        <!-- END: Third Child -->
                                    </li>
                                </ul>
                            </transition>
                            <!-- END: Second Child -->
                        </li>
                    </template>
                    <!-- END: First Child -->
                </ul>
                <img class="w-full mt-8 p-2" v-if="user.config_logo" :src="user.config_logo" alt="">
            </nav>
            <!-- END: Side Menu -->
            <!-- BEGIN: Content -->
            <div class="content">
                <TopBar />
                <router-view />
            </div>
            <!-- END: Content -->
        </div>
        <upload-file class="z-100"></upload-file>
        <crear-empleado class="z-100"></crear-empleado>
        <crear-subcontrata class="z-100"></crear-subcontrata>
        <crear-maquinaria class="z-100"></crear-maquinaria>
    </div>
</template>
<style scope>
.z-100 {
    z-index: 100;
}
</style>
<script>
import Velocity from "velocity-animate";
import TopBar from "@/components/TopBar";
import MobileMenu from "@/components/MobileMenu";
import SideMenuTooltip from "@/components/SideMenuTooltip";
import UploadFile from "@/components/UploadFile";
import CrearEmpleado from "@/components/CrearEmpleado";
import CrearSubcontrata from "@/components/CrearSubcontrata";
import CrearMaquinaria from "@/components/CrearMaquinaria";

export default {
    components: {
        SideMenuTooltip,
        MobileMenu,
        TopBar,
        UploadFile,
        CrearEmpleado,
        CrearMaquinaria,
        CrearSubcontrata,
    },
    data() {
        return {
            user: {},
            formattedMenu: []
        };
    },
    computed: {
        isAdmin() {
            return window.bus.admin;
        },
        sideMenu() {
            if (window.bus.admin) return this.nestedMenu(this.$store.state.sideMenu.admin_menu);
            return this.nestedMenu(this.$store.state.sideMenu.menu);
        }
    },
    watch: {
        $route() {
            this.formattedMenu = this.$h.assign(this.sideMenu);
        }
    },
    mounted() {
        cash("body")
            .removeClass("login")
            .addClass("app");
        this.formattedMenu = this.$h.assign(this.sideMenu);
        window.bus.$on("dataReloaded", () => {
            this.reload();
        });
        window.bus.$on("visionGlobal", () => {
            this.visionGlobal();
        });
        this.reload();
    },
    methods: {
        emitVisionGlobal() {
            window.bus.$emit('visionGlobal');
            if(["side-menu-empresas-y-centros","side-menu-empresa-resumen","side-menu-ultimos-docs","side-menu-control-docs"].indexOf(this.$router.history.current.name) === -1) {
                this.$router.push('empresas-y-centros');
            }
        },
        visionGlobal() {
            // reutilizo esta función porque simplemente reloguea al admin quitándole la empresa seleccionada
            CmsApi.hook("/hooks/login/",{empresa: 'crear'}, (data) => {
                if (data.success) {
                    window.bus.$emit("reloadDataFromServer", data);
                }
            });
        },
        reload() {
            this.user = this.$d().user;
        },
        nestedMenu(menu) {
            menu.forEach((item, key) => {
                if (typeof item !== "string") {
                    menu[key].active =
                        (item.pageName == this.$route.name ||
                            this.$route.meta && this.$route.meta.prevs && this.$route.meta.prevs.indexOf(item.pageName) !== false(this.$h.isset(item.subMenu) &&
                                this.findActiveMenu(item.subMenu))) &&
                        !item.ignore;
                }

                if (this.$h.isset(item.subMenu)) {
                    menu[key].activeDropdown = this.findActiveMenu(item.subMenu);
                    menu[key] = {
                        ...item,
                        ...this.nestedMenu(item.subMenu)
                    };
                }
            });

            return menu;
        },
        findActiveMenu(subMenu) {
            let match = false;
            subMenu.forEach(item => {
                if (item.pageName == this.$route.name && !item.ignore) {
                    match = true;
                } else if (!match && this.$h.isset(item.subMenu)) {
                    match = this.findActiveMenu(item.subMenu);
                }
            });
            return match;
        },
        linkTo(menu) {
            if (this.$h.isset(menu.subMenu)) {
                menu.activeDropdown = !menu.activeDropdown;
            } else {
                this.$router.push({
                    name: menu.pageName
                }).catch((err) => {
                    console.info('Error catcheado')
                });
            }
        },
        enter(el, done) {
            Velocity(
                el,
                "slideDown", {
                    duration: 300
                }, {
                    complete: done
                }
            );
        },
        leave(el, done) {
            Velocity(
                el,
                "slideUp", {
                    duration: 300
                }, {
                    complete: done
                }
            );
        }
    }
};
</script>